/**
 * @mui/x-telemetry v8.4.0
 *
 * @license MUI X Commercial
 * This source code is licensed under the commercial license found in the
 * LICENSE file in the root directory of this source tree.
 */
import muiXTelemetryEvents from "./runtime/events.js";
import sendMuiXTelemetryEventOriginal from "./runtime/sender.js";
import muiXTelemetrySettingsOriginal from "./runtime/settings.js";
const noop = () => {};

// To cut unused imports in production as early as possible
const sendMuiXTelemetryEvent = process.env.NODE_ENV === 'production' ? noop : sendMuiXTelemetryEventOriginal;

// To cut unused imports in production as early as possible
const muiXTelemetrySettings = process.env.NODE_ENV === 'production' ? {
  enableDebug: noop,
  enableTelemetry: noop,
  disableTelemetry: noop
} : muiXTelemetrySettingsOriginal;
export { muiXTelemetryEvents, sendMuiXTelemetryEvent, muiXTelemetrySettings };